import es from 'dayjs/locale/es'
import en from 'dayjs/locale/en'

export const locales = { es, en }
